import React, { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import { TargetingContextProvider } from '@features/targeting/hooks/useTargetingContextProvider';

export const TargetingRouteWithContext = (): ReactElement => {
  return (
    <TargetingContextProvider>
      <Outlet />
    </TargetingContextProvider>
  );
};
